'use strict';

var distinctArray = require('./distinctArray.js');

/**
 * Adds a value to an array, ensuring that the resulting array contains only distinct values.
 *
 * @template T - The type of elements in the array (must be string or number).
 * @param {T[]} arr - The array to add the value to.
 * @param {T} value - The value to add to the array.
 * @returns {T[]} - The resulting array with the value added.
 */ function addToDistinctArray(arr, value) {
    return distinctArray([
        ...arr,
        value
    ]);
}

module.exports = addToDistinctArray;
